import React, { useState } from 'react';
import { Modal } from '@components/utils/Modal';
import type { Dashboard } from '@/types/dashboard';
import { dashboardService } from '@/services/dashboardService';

interface DeleteDashboardModalProps {
  dashboard: Dashboard;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  activeDashboard: number;
  dashboards: Dashboard[];
  setTabsToShow: React.Dispatch<React.SetStateAction<Dashboard[]>>;
  selectDashboard: (dashboard: Dashboard) => void;
}

export const DeleteDashboardModal: React.FC<any> = ({
  dashboard,
  open,
  setOpen,
  activeDashboard,
  dashboards,
  setTabsToShow,
  selectDashboard,
}: DeleteDashboardModalProps) =>
{
  const [loading, setLoading] = useState(false);
  const deleteDashboard = async (): Promise<void> =>
  {
    if (loading) return;
    setLoading(true);
    await dashboardService.DeleteDashboard(dashboard.DashboardId);
    // Remove from tabs
    const getIndex: number = dashboards.findIndex(d => d.DashboardId === dashboard.DashboardId) - 1;
    setTabsToShow(dashboards.filter(d => d.DashboardId !== dashboard.DashboardId));
    dashboards = dashboards.filter(d => d.DashboardId !== dashboard.DashboardId);
    setOpen(false);
    setLoading(false);
    if (activeDashboard === dashboard.DashboardId)
    {
      selectDashboard((dashboards[getIndex] || dashboards[0])!);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() =>
      {
        setOpen(false);
        setLoading(false);
      }}
      title="Delete Dashboard"
    >
      <div>
        <p className="pt-[10px] pb-[8px] px-[20px] text-sm">
          Are you sure you want to delete this dashboard? This action cannot be undone.
        </p>
        <div className="pt-3 text-right gap-[10px] relative overflow-hidden min-h-6 flex flex-row-reverse">
          <button
            type="button"
            disabled={loading}
            onClick={() =>
            {
              deleteDashboard();
            }}
            className="bg-corgee-blue dark:bg-[#3c6c80] hover:bg-corgee-BlueHover dark:hover:brightness-[0.85] text-white text-xs h-7 px-3 py-1"
          >
            Yes
          </button>
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="bg-brightGray hover:bg-corgee-brightGrayHover   text-white text-xs h-7 px-3 py-1"
          >
            No
          </button>
        </div>
      </div>
    </Modal>
  );
};
